<template>
	<div>
		<div class="row">
			<div class="col-sm-8">
				<div class="border-gray bg-w p-3 flex justify-content-between">
					<div class="ftr-1-25 ftw600">
						{{ $t('wallet.myWalletTeacher') }}
					</div>
					<button type="button" class="btn btn-theme px-3"
						@click="visible = true">{{ $t('wallet.withdraw') }}</button>
				</div>
				<div class="border-gray bg-w p-3 px-4" style="border-top: none !important;">
					<div class="cl-info flex alcenter">
						<span class="mr40">
							{{ $t('wallet.availableBalance') }}
						</span>
						<a-tooltip placement="rightTop">
							<template #title>
								<div class="ft14 ftw600">{{ $t('wallet.hint1') }}</div>
							</template>
							<img src="../../../assets/image/staduents/1.png" width="20px" height="20px" />
						</a-tooltip>
					</div>
					<div class="ftr-2 mt-2">
						{{convertCurrency(teacherInfo.money)}} {{getCurrency()}}
					</div>
					<div class="mt-2">
						USD {{ (Number(teacherInfo.money) * Number(rate)).toFixed(2) }}
					</div>
					<!-- <div class="bg-orange mt-4" style="width: 20px;height: 2px;">
						
					</div> -->
					<div class="flex mt-4">
						<div>
							<div class="flex">
								<span class="mr40">
									{{ $t('wallet.totalBalance') }}
								</span>
								<a-tooltip placement="rightTop">
									<template #title>
										<div class="ft14 ftw600">{{ $t('wallet.hint2') }}</div>
									</template>
									<img src="../../../assets/image/staduents/1.png" width="20px" height="20px" />
								</a-tooltip>
							</div>
							<div class="ftr-1-5 mt-2">
								{{convertCurrency(teacherInfo.accumulative_money)}} {{getCurrency()}}
							</div>
							<div class="mt-2">
								USD {{ (Number(teacherInfo.accumulative_money) * Number(rate)).toFixed(2) }}
							</div>
						</div>
						<div class="ms-sm-5">
							<div class="flex">
								<span class="mr40">
									{{ $t('wallet.pendingBalance') }}
								</span>
								<a-tooltip placement="rightTop">
									<template #title>
										<div class="ft14 ftw600">{{ $t('wallet.hint3') }}</div>
									</template>
									<img src="../../../assets/image/staduents/1.png" width="20px" height="20px" />
								</a-tooltip>
							</div>
							<div class="ftr-1-5 mt-2">
								{{convertCurrency(teacherInfo.experience_price)}} {{getCurrency()}}
							</div>
							<div class="mt-2">
								USD {{ (Number(teacherInfo.experience_price) * Number(rate)).toFixed(2) }}
							</div>
						</div>
					</div>
					<div class="cl-info mt-4">
						{{ $t('wallet.approximateAmountNote') }}
					</div>
				</div>
				<div class="border-gray bg-w p-3 mt-4 flex " style="padding-bottom: 0 !important;">
					<div class="ftr-1 ftw600  clickAct" @click="changeTab(1)" :class="tabIndex==1?'cl-theme':''"
						:style="tabIndex==1?'border-bottom: 3px solid #52C4C9;padding-bottom: 0.5rem;':''">
						{{ $t('wallet.ordercontent1') }}
					</div>
					<div class="ftr-1 ftw600 ml20 clickAct" @click="changeTab(2)" :class="tabIndex==2?'cl-theme':''"
						:style="tabIndex==2?'border-bottom: 3px solid #52C4C9;padding-bottom: 0.5rem;':''">
						{{ $t('wallet.ordercontent2') }}
					</div>
					<div class="ftr-1 ftw600 ml20 clickAct" @click="changeTab(3)" :class="tabIndex==3?'cl-theme':''"
						:style="tabIndex==3?'border-bottom: 3px solid #52C4C9;padding-bottom: 0.5rem;':''">
						{{ $t('wallet.ordercontent3') }}
					</div>
					<div class="ftr-1 ftw600 ml20 clickAct" @click="changeTab(4)" :class="tabIndex==4?'cl-theme':''"
						:style="tabIndex==4?'border-bottom: 3px solid #52C4C9;padding-bottom: 0.5rem;':''">
						{{ $t('wallet.ordercontent4') }}
					</div>
				</div>
				<div class="bg-w flex alcenter px-4 pt-3" v-if="tabIndex!=3"
					style="border-left: 1px solid #E2E1E2;border-right: 1px solid #E2E1E2;">
					<div class="mx-2 ftr-1 clickAct" :class="timeIndex==0?'cl-theme':'cl-black'" @click="changeTime(0)">
						{{ $t('wallet.ordercontent5') }}
					</div>
					<div class="mx-2 ftr-1 clickAct" :class="timeIndex==1?'cl-theme':'cl-black'" @click="changeTime(1)">
						{{ $t('wallet.ordercontent6') }}
					</div>
					<div class="mx-2 ftr-1 clickAct" :class="timeIndex==2?'cl-theme':'cl-black'" @click="changeTime(2)">
						{{ $t('wallet.ordercontent7') }}
					</div>
					<div class="mx-2 ftr-1 clickAct" :class="timeIndex==3?'cl-theme':'cl-black'" @click="changeTime(3)">
						{{ $t('wallet.ordercontent8') }}
					</div>
					<a-range-picker valueFormat="YYYY-MM-DD" style="width: 200px;" class="ml10" v-model="customTime" @change="changeRangeTime" />
				</div>
				<div class="border-gray bg-w px-4 pt-3" style="border-top: none !important;" v-if="tabIndex==1">
					<a-table :columns="columnsClass" rowKey="id" class="" :data-source="moneyList"
						:scroll="{x:1200,y:500}">
						<div slot="createtime" slot-scope="record, index">
							{{ convertToTimeZone(record.createtime).formattedTime}}
						</div>
						<div slot="is_experience" slot-scope="record, index">
							<div class="" style="width: 120px;">
								{{record.is_experience=='1'?'試堂':'正式課'}}
							</div>
						</div>
					</a-table>
				</div>
				<div class="border-gray bg-w px-4 pt-3"
					style="border-top: none !important;max-width: 1500px;overflow-x: scroll;" v-if="tabIndex==2">
					<a-table :columns="columnsClass2" rowKey="id" class="" :data-source="moneyList"
						:scroll="{x:1200,y:500}">
						<div slot="createtime" slot-scope="record, index">
							{{ convertToTimeZone(record.createtime).formattedTime}}
						</div>
						<div slot="is_experience" slot-scope="record, index">
							<div class="" style="width: 120px;">
								{{record.is_experience=='1'?'試堂':'正式課'}}
							</div>
						</div>
					</a-table>

				</div>
				<div class="border-gray bg-w px-4 pt-3"
					style="border-top: none !important;max-width: 1500px;overflow-x: scroll;" v-if="tabIndex==3">
					<a-table :columns="columnsClass3" rowKey="id" class="" :data-source="moneyList"
						:scroll="{x:1200,y:500}">
						<div slot="createtime" slot-scope="record, index">
							{{ convertToTimeZone(record.createtime).formattedTime}}
						</div>
						<div slot="type" slot-scope="record, index">
							<span v-if="record.type=='1'">{{ $t('wallet.paypal') }}</span>
							<span v-if="record.type=='2'">{{ $t('wallet.fps') }}</span>
							<span v-if="record.type=='3'">{{ $t('teacherSet.bankTransfer') }}</span>
						</div>
						<div slot="status" slot-scope="record, index">
							<span v-if="record.status=='1'">審核中</span>
							<span v-if="record.status=='2'">已通過</span>
							<span v-if="record.status=='3'">已駁回</span>
							<span v-if="record.status=='4'">已取消</span>
						</div>
						
					</a-table>
				</div>
				<div class="border-gray bg-w px-4 pt-3"
					style="border-top: none !important;max-width: 1500px;overflow-x: scroll;" v-if="tabIndex==4">
					<a-table :columns="columnsClass4" rowKey="id" class="" :data-source="moneyList"
						:scroll="{x:1200,y:500}">
						<div slot="createtime" slot-scope="record, index">
							{{ convertToTimeZone(record.createtime).formattedTime}}
						</div>
						<div slot="is_experience" slot-scope="record, index">
							<div class="" style="width: 120px;">
								{{record.is_experience=='1'?'試堂':'正式課'}}
							</div>
						</div>
					</a-table>
				</div>
			</div>
			<div class="col-sm">
				<div class="border-gray bg-w p-3 px-4">
					<div class="ftr-1-25 ftw600">
						{{ $t('wallet.myWalletTutor') }}
					</div>
					<div class="flex mt-4">
						<span class="mr40">
							{{ $t('wallet.availableBalance') }}
						</span>
						<a-tooltip placement="rightTop">
							<template #title>
								<div class="ft14 ftw600">{{ $t('wallet.availableBalance') }}</div>
							</template>
							<img src="../../../assets/image/staduents/1.png" width="20px" height="20px" />
						</a-tooltip>
					</div>
					<div class="ftr-1-5 mt-2">
						{{convertCurrency(teacherInfo.money)}} {{getCurrency()}}
					</div>
					<div class="mt-2">
						USD 74.30
					</div>
					<button type="button" class="btn btn-outline-dark mt-3"
						@click="visibleToStudents = true">{{ $t('wallet.transferToStudentWallet') }}</button>

				</div>
			</div>
		</div>
		<a-modal :title="null" :width="650" :visible="visible" @cancel="handleCancel" :closable="false" :footer="null">
			<div class="text-center ftr-1-25 cl-black flex alcenter center">
				{{$t('wallet.withdrawFromInternalAccount')}}
				<a-icon type="question-circle" class="ml10" size="14" @click="visibleHint = true"></a-icon>
			</div>
			<div class="cl-black ftr-1">
				<div class="ftw600">
					{{ $t('wallet.transferMethod') }}
				</div>
				<div class="flex mt-2">
					<div class="px-3 py-2 br8 clickAct" @click="type=1" :class="type==1?'bg-theme cl-w': 'border-gray'">
						{{ $t('wallet.paypal') }}
					</div>
					<div class="px-3 py-2 br8 ml10 clickAct" @click="type=2"
						:class="type==2?'bg-theme cl-w': 'border-gray'">
						{{ $t('wallet.fps') }}
					</div>
					<div class="px-3 py-2 br8 ml10 clickAct" @click="type=3"
						:class="type==3?'bg-theme cl-w': 'border-gray'">
						{{ $t('teacherSet.bankTransfer') }}
					</div>
				</div>
				<div v-if="type==1">
					<div class="ftw600 mt-3">
						{{ $t('wallet.email') }}
					</div>
					<div>
						{{teacherInfo.withdraw_paypal}}
					</div>
				</div>
				<div v-if="type==2">
					<div class="ftw600 mt-3">
						收款人姓名
					</div>
					<div>
						{{teacherInfo.name}}{{teacherInfo.surname}}
					</div>
					<div class="ftw600 mt-3">
						轉數快FPS號碼
					</div>
					<div>
						{{teacherInfo.withdraw_zhuanshukuai}}
					</div>
				</div>
				<div v-if="type==3">
					<div class="ftw600 mt-3">
						收款人姓名
					</div>
					<div>
						{{teacherInfo.name}}{{teacherInfo.surname}}
					</div>
					<div class="ftw600 mt-3">
						銀行名稱
					</div>
					<div>
						{{teacherInfo.withdraw_bank_name}}
					</div>
					<div class="ftw600 mt-3">
						銀行賬戶號碼
					</div>
					<div>
						{{teacherInfo.withdraw_bank_number}}
					</div>
				</div>

				<div class="mt-3">
					<span class="ftw600 mr10">{{ $t('wallet.withdrawAmount') }}</span>
					{{ $t('wallet.maxWithdraw', { amount: convertCurrency(teacherInfo.money), currency: getCurrency() }) }}
				</div>
				<a-input :placeholder="'每次最少提款為HK$100'" class="mt-2" v-model="money"></a-input>
				<div class="mt-4 d-flex justify-content-center">
					<button type="button" class="btn btn-outline-gray px-4" @click="handleCancel()">
						{{ $t('wallet.cancel') }} </button>
					<button type="button" class="btn btn-theme ml16 px-4"
						@click="visibleDetails = true">{{ $t('wallet.withdrawProfit') }}</button>
				</div>
			</div>

			<a-modal :title="null" :width="500" :visible="visibleHint" @cancel="visibleHint = false" :closable="false"
				:footer="null">
				<div class="cl-black">
					<div class="">
						提款安排及細則
					</div>
					<div class="mt-3">
						1. 我們會在每月最後一天結算及處理所有申請。
					</div>
					<div class="mt-1">
						2. 一般情況下，我們會在申請月份的下個月首10天或以內，將款項轉給你。 例如：你於6月30日提出申請，款項將於7月10日或之前轉賬。
					</div>
					<div class="mt-3">
						其他須知
					</div>
					<div class="mt-1">
						1. 以上期限均以香港時區為準。
					</div>
					<div class="mt-1">
						2. 所有款項以港元 (HK$) 支付。
					</div>
					<div class="mt-1">
						3. 款項只會發放至老師的個人戶口，不接受轉賬至他人（包括親屬）戶口或聯名戶口。
					</div>
					<div class="mt-1">
						4. 銀行轉賬服務暫只支援本地（香港）銀行，如需跨境匯款，請使用 PayPal。
					</div>
					<div class="mt-1">
						5. 如使用 PayPal 收款，可能涉及收款費用，詳情請向該公司查詢。
					</div>
					<div class="mt-4 flex center">
						<div class="btn btn-theme" @click="visibleHint = false">
							知道了
						</div>
					</div>
				</div>
			</a-modal>
			<a-modal title="提款詳情" :width="500" :visible="visibleDetails" @cancel="visibleDetails = false"
				:closable="false" :footer="null">
				<!-- <div class="mt-3 flex space">
					<span>
						提款編號  
					</span>
					<span>
						
					</span>
				</div> -->
				<div class="mt-3 flex space">
					<span>
						申請時間
					</span>
					<span>
						{{getTime()}}
					</span>
				</div>
				<div class="mt-3 flex space">
					<span>
						提款金額
					</span>
					<span>
						{{getCurrency()}}{{money}}
					</span>
				</div>
				<div class="mt-3 flex space">
					<span>
						提款方法
					</span>
					<span v-if="type==1">
						{{ $t('wallet.paypal') }}
					</span>
					<span v-if="type==2">
						{{ $t('wallet.fps') }}
					</span>
					<span v-if="type==3">
						{{ $t('teacherSet.bankTransfer') }}
					</span>
				</div>
				<div class="mt-3 flex space">
					<div>
						手續費 <span style="text-decoration-line: line-through;">1%</span> 免費
					</div>
					<span>
						{{getCurrency()}}0.00
					</span>
				</div>
				<hr />
				<div class="mt-3">
					款項一般在申請月份的下個月首10天或以內，轉到你指定的賬戶。你可在「我的錢包」留意最新狀況。
				</div>
				<div class="mt-4 flex around">
					<div class="btn btn-theme" style="width: 120px;" @click="createWithdraw()">
						確認
					</div>
					<div class="btn btn-outline-gray" style="width: 120px;" @click="visibleDetails = false">
						修改
					</div>
				</div>
			</a-modal>
		</a-modal>
		<a-modal :title="$t('wallet.transferToStudent')" :width="650" :visible="visibleToStudents"
			@cancel="handleCancelStudents" :closable="false" :footer="null">
			<div class="cl-black ftr-1">
				<div class="mt-3">
					<span class="ftw600 mr10">{{ $t('wallet.withdrawAmount') }}</span>
					{{ $t('wallet.maxWithdraw', { amount: convertCurrency(teacherInfo.money), currency: getCurrency() }) }}
				</div>
				<a-input :placeholder="$t('wallet.enter')" class="mt-2" v-model="moneyStudents"></a-input>
				<div class="mt-4 d-flex justify-content-center">
					<button type="button" class="btn btn-outline-gray px-4" @click="handleCancelStudents()">
						{{ $t('wallet.cancel') }} </button>
					<button type="button" class="btn btn-theme ml16 px-4"
						@click="withdrawUserMoney()">{{ $t('wallet.confirm') }}</button>
				</div>
			</div>
		</a-modal>

	</div>
</template>


<script>
	export default {
		data() {
			return {
				tabIndex: 1,
				visible: false,
				visibleToStudents: false,
				type: '1', //类型:1=paypal,2=转数快
				email: '',
				money: '',
				list: [], //提现列表
				moneyList: [], //钱包交易详情
				moneyStudents: 0,
				rate: 1,
				visibleHint: false,
				visibleDetails: false,
				timeIndex: 0,
				customTime: [],

				columnsClass: [{
						title: this.$t('wallet.time'),
						key: 'createtime',
						scopedSlots: {
							customRender: "createtime"
						},
					},
					{
						title: this.$t('wallet.ordercontent9'),
						dataIndex: "order_sn",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent10'),
						dataIndex: "course_name",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent11'),
						key: "is_experience",
						align: "left",
						scopedSlots: {
							customRender: "is_experience"
						},
					},
					{
						title: this.$t('wallet.ordercontent12'),
						dataIndex: "nickname",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent13'),
						dataIndex: "id",
						align: "left",
					},
					{
						title: this.$t('wallet.amount', {
							currency: this.getCurrency()
						}),
						dataIndex: "before",
						align: "left",
					},

					{
						title: this.$t('wallet.ordercontent14'),
						dataIndex: "after",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent15'),
						dataIndex: "memo",
						align: "left",
					},
				],
				columnsClass2: [{
						title: this.$t('wallet.time'),
						key: 'createtime',
						scopedSlots: {
							customRender: "createtime"
						},
					},
					{
						title: this.$t('wallet.ordercontent9'),
						dataIndex: "order_sn",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent10'),
						dataIndex: "course_name",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent11'),
						key: "is_experience",
						align: "left",
						scopedSlots: {
							customRender: "is_experience"
						},
					},
					{
						title: this.$t('wallet.ordercontent12'),
						dataIndex: "nickname",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent13'),
						dataIndex: "id",
						align: "left",
					},
					{
						title: this.$t('wallet.amount', {
							currency: this.getCurrency()
						}),
						dataIndex: "before",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent15'),
						dataIndex: "memo",
						align: "left",
					},
				],
				columnsClass3: [{
						title: this.$t('wallet.ordercontent16'),
						key: 'createtime',
						scopedSlots: {
							customRender: "createtime"
						},
					},
					{
						title: this.$t('wallet.ordercontent17'),
						dataIndex: "order_sn",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent18'),
						key: "type",
						align: "left",
						scopedSlots: {
							customRender: "type"
						},
					},
					{
						title: this.$t('wallet.ordercontent19')+'('+this.getCurrency()+')',
						dataIndex: "money",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent20'),
						key: "status",
						align: "left",
						scopedSlots: {
							customRender: "status"
						},
					},
					// {
					// 	title: this.$t('wallet.ordercontent15'),
					// 	dataIndex: "updatetime",
					// 	align: "left",
					// },
					{
						title: this.$t('wallet.ordercontent21'),
						dataIndex: "updatetime",
						align: "left",
					},
				],
				columnsClass4:[
					{
							title: this.$t('wallet.ordercontent8'),
							key: 'createtime',
							scopedSlots: {
								customRender: "createtime"
							},
						},
					{
						title: this.$t('wallet.ordercontent23'),
						dataIndex: "order_sn",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent10'),
						dataIndex: "course_name",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent11'),
						key: "is_experience",
						align: "left",
						scopedSlots: {
							customRender: "is_experience"
						},
					},
					// {
					// 	title: this.$t('wallet.ordercontent10'),
					// 	dataIndex: "course_name",
					// 	align: "left",
					// },
					{
						title: this.$t('wallet.ordercontent24'),
						dataIndex: "quantity",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent12'),
						dataIndex: "nickname",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent22'),
						dataIndex: "before",
						align: "left",
					},
					{
						title: this.$t('wallet.ordercontent15'),
						dataIndex: "memo",
						align: "left",
					},
				],
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				ltype:0,//变更类型:1=增加,2=减少
				source:0,//变更来源:1=后台增加,2=后台减少,3=课程结算,4=提现扣除,5=提现驳回,6=取消提现,7=转账学生钱包
				createtime_min:'',
				createtime_max:''
			}
		},
		created() {
			this.withdrawList()
			this.createtime_min = this.getDateRanges().thisMonth.start
			this.createtime_max = this.getDateRanges().thisMonth.end
			this.moneyLogList()
			this.getrealRate()
		},
		methods: {
			getDateRanges() {
			  let today = new Date();
			 
			   // 本月的开始日期和结束日期
			   let startOfMonth = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1));  // 本月第一天，00:00:00 UTC
			   let endOfMonth = new Date(Date.UTC(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59, 999));  // 本月最后一天，23:59:59.999 UTC
			 
			   // 上月的开始日期和结束日期
			   let lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
			   let startOfLastMonth = new Date(Date.UTC(lastMonth.getFullYear(), lastMonth.getMonth(), 1));  // 上月第一天，00:00:00 UTC
			   let endOfLastMonth = new Date(Date.UTC(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0, 23, 59, 59, 999));  // 上月最后一天，23:59:59.999 UTC
			   
			  // 近一年的开始日期和结束日期
			   let lastYearStart = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
			   let startOfLastYear = new Date(Date.UTC(lastYearStart.getFullYear(), lastYearStart.getMonth(), lastYearStart.getDate()));  // 去年同一日期，00:00:00 UTC
			   let endOfLastYear = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999));  // 当前日期，23:59:59.999 UTC
			   
			  // 返回整合的日期数据
			  return {
			    thisMonth: {
			      start: startOfMonth.toISOString().split('T')[0], // 格式化为 YYYY-MM-DD
			      end: endOfMonth.toISOString().split('T')[0]
			    },
			    lastMonth: {
			      start: startOfLastMonth.toISOString().split('T')[0],
			      end: endOfLastMonth.toISOString().split('T')[0]
			    },
			    lastYear: {
			      start: startOfLastYear.toISOString().split('T')[0],
			      end: endOfLastYear.toISOString().split('T')[0]
			    }
			  };
			},
			
			changeRangeTime(){
				this.createtime_min = this.customTime[0]
				this.createtime_max = this.customTime[1]
				this.moneyLogList()
			},
			changeTab(index){
				this.tabIndex = index
				if(index==1){
					this.source = 0
					this.ltype==0
				}else if(index==2){
					this.ltype==1
				}else if(index==3){
					this.source = 7
					this.ltype==0
				}else{
					this.source = 3
					this.ltype==0
				}
				this.moneyLogList()
			},
			changeTime(num) {
				this.timeIndex = num
				if(num==0){
					this.createtime_min = this.getDateRanges().thisMonth.start
					this.createtime_max = this.getDateRanges().thisMonth.end
				}else if(num==1){
					this.createtime_min = this.getDateRanges().lastMonth.start
					this.createtime_max = this.getDateRanges().lastMonth.end
				}else if(num==2){
					this.createtime_min = this.getDateRanges().lastYear.start
					this.createtime_max = this.getDateRanges().lastYear.end
				}else{
					this.createtime_min = ''
					this.createtime_max = ''
				}
				this.moneyLogList()
			},
			getTime() {
				// 获取当前时间
				let currentDate = new Date();

				// 获取年份、月份、日期、小时和分钟
				let year = currentDate.getFullYear();
				let month = currentDate.getMonth() + 1; // 月份从0开始，所以要加1
				let day = currentDate.getDate();
				let hours = currentDate.getHours();
				let minutes = currentDate.getMinutes();

				// 格式化成 YYYY-MM-DD HH:mm 格式
				let formattedDate =
					`${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`;
				return formattedDate
			},
			getrealRate() {
				this.$http.api('common/realRate', {
					currency: 'CNY'
				}).then(res => {
					this.rate = Number(res.result.list['USD'].rate)
				})
			},
			handleCancelStudents() {
				this.visibleToStudents = false
			},
			handleCancel() {
				this.visible = false
			},
			withdrawList() {
				this.$http.api('teacher/wallet/withdrawList', {
					page: 1,
					limit: 1000
				}).then(res => {
					this.list = res.list
				})
			},
			moneyLogList() {
				if(this.tabIndex==3){
					this.$http.api('teacher/wallet/withdrawList', {
						page: 1,
						limit: 1000
					}).then(res => {
						this.moneyList = res.list
					})
				}else{
					this.$http.api('teacher/wallet/moneyLogList', {
						page: 1,
						limit: 1000,
						ltype:this.ltype,
						source:this.source,
						createtime_min:this.createtime_min?this.createtime_min + ' 00:00:00':'',
						createtime_max:this.createtime_max?this.createtime_max + ' 23:59:59':'',
					}).then(res => {
						this.moneyList = res.list
						this.pagination.total = res.total
					})
				}
				
			},
			cancelWithdraw(id) {
				this.$confirm({
					title: this.$t('wallet.confirmCancel'),
					content: this.$t('wallet.cancel'),
					okText: this.$t('wallet.confirm'),
					okType: "danger",
					cancelText: this.$t('wallet.cancel'),
					okButtonProps: {
						style: {
							backgroundColor: '#52C4C9',
							borderColor: '#52C4C9',
							color: 'white'
						} // 设置确认按钮颜色
					},
					onOk: () => {
						this.$http.api('teacher/wallet/cancelWithdraw', {
							teacher_withdraw_id: id
						}).then(res => {
							this.$message.success(this.$t('wallet.operationSuccess'), 1, () => {
								this.withdrawList()
							})
						})
					},
					onCancel: () => {
						console.log("Cancel");
					},
				});

			},
			withdrawUserMoney() {
				this.$http.api('teacher/wallet/withdrawUserMoney', {
					money: this.moneyStudents
				}).then(res => {
					this.$message.success(this.$t('wallet.operationSuccess'), 1, () => {
						this.$http.api('teacher/teacher/info').then(res => {
							this.updateTeacherInfo(res.info)
							this.visibleToStudents = false
							this.visibleDetails = false
						})
					})
				})
			},
			// 申请提现
			createWithdraw() {

				this.$http.api('teacher/wallet/createWithdraw', {
					type: this.type,
					email: this.email,
					money: this.money
				}).then(res => {
					this.$message.success(this.$t('wallet.operationSuccess'), 1, () => {
						this.$http.api('teacher/teacher/info').then(res => {
							this.updateTeacherInfo(res.info)
							this.visible = false
							this.visibleDetails = false
						})
					})
				})


			},

		}
	}
</script>

<style>
</style>